module.exports = __webpack_public_path__ + "static/media/sem-foto.b675d873.jpg";